export default __webpack_public_path__ + "static/novos-pink-logo-64bc838bb61a3e40b3f9bddc40791ae5.png";